import { sessionService } from "./session.service";

// Marketing events are pushed to the GTM dataLayer only.
// Pixel routing (which Meta pixel receives which event) is configured in GTM.
export const trackingService = {
  pushPurchaseEvent(currency, amount) {
    window.dataLayer?.push({
      event: "purchase_completed",
      purchaseCurrency: currency || "-",
      purchaseValue: amount || "-",
      userEmail: sessionService?.getEmail() || "-",
    });

    // TODO: remove once GTM trackSingle routing is published and verified.
    // Legacy direct pixel call — broadcasts to ALL initialized pixels, and
    // will double-count on the attributed pixel once the GTM tags go live.
    // if (window.fbq) {
    //   window.fbq("track", "Purchase", {
    //     currency: currency || "-",
    //     value: amount || "-",
    //     email: sessionService?.getEmail() || "-",
    //   });
    // }
  },

  pushSignupEvent(email) {
    window.dataLayer?.push({
      event: "signup_completed",
      userEmail: email || "-",
    });

    // TODO: remove once GTM trackSingle routing is published and verified.
    // if (window.fbq) {
    //   window.fbq("track", "CompleteRegistration", {
    //     email: email || "-",
    //   });
    // }
  },
};
